import { ChevronLeft } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ChevronLeftIcon = createLucideIcon(ChevronLeft);
